import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useAsyncEffect from 'use-async-effect';
import { AddVehicleForm } from '@ui/components/Forms';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { createVehicle } from '@application/redux/whitelistBlacklistVehicle/vehicles-slice';
import { uploadFileAction } from '@application/redux/actions/fileActions';
import { fetchVehicleDetailAction, updateVehicleDetail } from '@application/redux/actions/vehicle-detail-actions';
const AddVehicleDialog = ({ isOpen, onClose, variant = 'add', listedCarId }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const newErrors = {};
    const [formData, setFormData] = useState({
        licensePlate: '',
        vehicleType: '',
        make: '',
        model: '',
        variant: '',
        color: '',
        isBlackListed: false,
        imageName: '',
        imageUrl: ''
    });
    const restForm = () => {
        setFormData({
            licensePlate: '',
            vehicleType: '',
            make: '',
            model: '',
            variant: '',
            color: '',
            isBlackListed: false,
            imageName: '',
            imageUrl: ''
        });
    };
    const handleClose = () => {
        onClose();
        restForm();
    };
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const handleSave = async (formData) => {
        try {
            setLoading(true);
            if (!formData.licensePlate) {
                newErrors.licensePlate = 'License# is required';
            }
            if (formData.licensePlate.length > 50) {
                newErrors.licensePlate = 'License# should not exceed 250 characters!';
            }
            if (/\d/.test(formData.color)) {
                newErrors.color = 'Color cannot contain numbers';
            }
            // if (formData.model! !== '' && !/^\d+$/.test(formData.model!)) {
            //   newErrors.model = 'Model must be numeric';
            // }
            var actualId = listedCarId || formData.id;
            if (Object.keys(newErrors).length === 0) {
                if (selectedFile && selectedFile[0].name) {
                    var fileResponse = await dispatch(uploadFileAction('VehicleDetails', selectedFile[0]));
                    if (fileResponse) {
                        const { blob } = fileResponse;
                        formData.imageName = blob.name;
                        formData.imageUrl = selectedFile[0].name || '';
                    }
                }
                var response = actualId
                    ? await dispatch(updateVehicleDetail(actualId, formData))
                    : await dispatch(createVehicle(formData));
                if (response.data && response.isSuccess) {
                    toast.success(response.message);
                }
                else {
                    toast.error(response?.message);
                }
            }
            {
                setErrors(newErrors);
                return;
            }
        }
        catch (error) {
            toast.error(t('FailedNotesError'));
        }
        finally {
            setLoading(false);
            if (Object.keys(newErrors).length === 0) {
                onClose();
            }
        }
    };
    useAsyncEffect(async () => {
        const actualId = listedCarId;
        if (actualId) {
            var response = await dispatch(fetchVehicleDetailAction(actualId));
            if (response?.data && response.isSuccess) {
                setFormData(response?.data);
            }
        }
    }, [listedCarId, isOpen]);
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', PaperProps: {
            sx: {
                width: '564px'
            }
        }, fullWidth: true, "aria-labelledby": 'ConfDialog', onKeyDown: (e) => e.key === 'Enter' && {}, children: [_jsxs(DialogTitle, { id: 'add-vehicle-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsxs(Typography, { variant: 'h6', color: 'text.primary', children: [variant === 'add' ? 'Add' : 'Edit', " Vehicle"] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(AddVehicleForm, { setVehicleDetails: setFormData, vehicleDetails: formData, errors: errors, setErrors: setErrors, setSelectedFile: setSelectedFile }) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: () => handleSave(formData), variant: 'contained', color: 'inherit', loading: loading, type: 'submit', children: t('SaveEntry') }), _jsx(Button, { onClick: handleClose, color: 'inherit', variant: 'outlined', children: "Cancel" })] })] }));
};
export default AddVehicleDialog;
